export default __webpack_public_path__ + "static/logo_white-c1dd971a3a274f3cdf60c9018cc6bb29.png";